var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94263 4.00008L7.80451 1.13814C8.06516 0.877482 8.06516 0.456157 7.80451 0.195496C7.54385 -0.0651653 7.12254 -0.0651653 6.86188 0.195496L4 3.05744L1.13812 0.195496C0.877463 -0.0651653 0.456148 -0.0651653 0.195492 0.195496C-0.065164 0.456157 -0.065164 0.877482 0.195492 1.13814L3.05737 4.00008L0.195492 6.86202C-0.065164 7.12269 -0.065164 7.54401 0.195492 7.80467C0.325486 7.93467 0.496146 8 0.666806 8C0.837465 8 1.00812 7.93467 1.13812 7.80467L4 4.94273L6.86188 7.80467C6.99188 7.93467 7.16254 8 7.33319 8C7.50385 8 7.67451 7.93467 7.80451 7.80467C8.06516 7.54401 8.06516 7.12269 7.80451 6.86202L4.94263 4.00008Z",
    fill: "#073041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.2d94df0bc4674b7c273146be39ba7075.svg";
export { ForwardRef as ReactComponent };